import React, { createContext, useContext, useState, ReactNode, Key } from 'react';

interface EmittedTitlesTableContextType {
  page: number;
  pageSize: number;
  ordering: string | undefined;
  brokerName: Key[];
  collectiveContractCode: Key[];
  confirmed: Key[];
  contractCode: Key[];
  contractor: Key[];
  credit: Key[];
  debit: Key[];
  documentName: Key[];
  productCode: Key[];
  startDate: Key[];
  taxableAmount: Key[];
  movementCode: Key[];
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  setOrdering: (ordering: string) => void;
  setBrokerName: (brokerName: Key[]) => void;
  setCollectiveContractCode: (collectiveContractCode: Key[]) => void;
  setConfirmed: (confirmed: Key[]) => void;
  setContractCode: (contractCode: Key[]) => void;
  setContractor: (contractor: Key[]) => void;
  setCredit: (credit: Key[]) => void;
  setStartDate: (startDate: Key[]) => void;
  setDebit: (debit: Key[]) => void;
  setDocumentName: (documentName: Key[]) => void;
  setProductCode: (productCode: Key[]) => void;
  setTaxableAmount: (taxableAmount: Key[]) => void;
  setMovementCode: (movementCode: Key[]) => void;
}

const EmittedTitlesTableContext = createContext<EmittedTitlesTableContextType | undefined>(undefined);

export const EmittedTitlesTableProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [ordering, setOrdering] = useState<string | undefined>(undefined);
  const [brokerName, setBrokerName] = useState<Key[]>([]);
  const [credit, setCredit] = useState<Key[]>([]);
  const [debit, setDebit] = useState<Key[]>([]);
  const [documentName, setDocumentName] = useState<Key[]>([]);
  const [startDate, setStartDate] = useState<Key[]>([]);
  const [productCode, setProductCode] = useState<Key[]>([]);
  const [taxableAmount, setTaxableAmount] = useState<Key[]>([]);
  const [collectiveContractCode, setCollectiveContractCode] = useState<Key[]>([]);
  const [contractCode, setContractCode] = useState<Key[]>([]);
  const [contractor, setContractor] = useState<Key[]>([]);
  const [movementCode, setMovementCode] = useState<Key[]>([]);
  const [confirmed, setConfirmed] = useState<Key[]>([]);

  const value: EmittedTitlesTableContextType = {
    page,
    pageSize,
    ordering,
    brokerName,
    collectiveContractCode,
    confirmed,
    contractCode,
    contractor,
    credit,
    debit,
    documentName,
    productCode,
    startDate,
    taxableAmount,
    movementCode,
    setBrokerName,
    setCollectiveContractCode,
    setConfirmed,
    setContractCode,
    setContractor,
    setCredit,
    setDebit,
    setDocumentName,
    setPage,
    setPageSize,
    setOrdering,
    setProductCode,
    setStartDate,
    setTaxableAmount,
    setMovementCode
  };

  return (
    <EmittedTitlesTableContext.Provider value={value}>
      {children}
    </EmittedTitlesTableContext.Provider>
  );
};

export const useEmittedTitlesTable = (): EmittedTitlesTableContextType => {
  const context = useContext(EmittedTitlesTableContext);
  if (context === undefined) {
    throw new Error('useEmittedTitlesTable deve essere utilizzato all\'interno di un EmittedTitlesTableProvider');
  }
  return context;
};